import './style.css';

import { createApp, Plugin } from 'vue';

import { createPinia } from 'pinia';

import router from '@/core/router';

import { useMediaLoader } from '@/shared/composables/useMediaLoader';
import { mediaLoaderInjectionKey } from '@/core/injection-keys.ts';
import * as plugins from '@/core/plugins';
import { IonicVue } from '@ionic/vue';
import App from './App.vue';
import * as ApolloComposable from '@vue/apollo-composable';
import { Capacitor } from '@capacitor/core';
import { clickOutside } from '@/shared/directives/slick-outside.ts';
import { removePreloadFont } from '@/shared/tools/remove-preload-fonts';
import { smoothFadeAnimation } from '@/shared/animations/smooth-fade.ts';
import { apolloClient } from '@/core/apollo/client';
import { IconsPlugin } from '@/core/plugins/icons';
import { keepAwake } from '@/shared/directives/keep-awake.ts';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css'; /* перезатирає стилі кнопок */
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/display.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';

const pinia = createPinia();

import { registerModules } from '@/core/register-modules.ts';

import { AuthModule } from '@/modules/auth';
import { InteractiveExperienceModule } from '@/modules/interactive-experience';
import { StoriesModule } from '@/modules/stories';
import { PrayerExperienceModule } from '@/modules/prayer-experience';
import { ProfileModule } from '@/modules/profile';
import { VideoExperienceModule } from '@/modules/video-experience';
import { ReadingPlanModule } from '@/modules/reading-plan';
import { ContactUsModule } from '@/modules/contact-us';
import { HomeModule } from '@/modules/home';
import { OnboardingModule } from '@/modules/onboarding';
import { InviteModule } from '@/modules/invite';
import { AdminModule } from '@/modules/admin';
import { AdminPrayerTalksModule } from '@/modules/admin-prayer-talks';
import { AdminReadingPlansModule } from '@/modules/admin-reading-plans';
import { AdminStoriesModule } from '@/modules/admin-stories';
import { AdminExpertCommentaryModule } from '@/modules/admin-expert-commentary';
import { TextBibleModule } from '@/modules/text-bible';

if (!Capacitor.isNativePlatform()) {
  removePreloadFont('/src/assets/fonts/songti-tc-regular.woff2');
  removePreloadFont('/src/assets/fonts/songti-tc-bold.woff2');
}

const mediaLoader = useMediaLoader();

registerModules({
  videoExperience: VideoExperienceModule,
  prayerExperience: PrayerExperienceModule,
  interactiveExperience: InteractiveExperienceModule,
  stories: StoriesModule,
  readingPlan: ReadingPlanModule,
  auth: AuthModule,
  profile: ProfileModule,
  contactUs: ContactUsModule,
  home: HomeModule,
  onboarding: OnboardingModule,
  invite: InviteModule,
  admin: AdminModule,
  adminPrayerTalks: AdminPrayerTalksModule,
  adminReadingPlans: AdminReadingPlansModule,
  adminStories: AdminStoriesModule,
  adminExpertCommentary: AdminExpertCommentaryModule,
  textBible: TextBibleModule,
});

const app = createApp(App)
  .provide(mediaLoaderInjectionKey, mediaLoader)
  .use(IonicVue, {
    animated: true,
    navAnimation: smoothFadeAnimation,
  })
  .use(router)
  .use(pinia)
  .use(IconsPlugin)
  .directive('click-outside', clickOutside)
  .directive('keep-awake', keepAwake)
  .provide(ApolloComposable.ApolloClients, {
    default: apolloClient,
  });

// if (Capacitor.isNativePlatform()) {
//   app.config.errorHandler = globalSyncErrorHandler;
//
//   window.addEventListener('unhandledrejection', globalAsyncErrorHandler);
// }

for (const plugin of (Object.values(plugins) as Plugin[])) {
  app.use(plugin);
}

app.mount('#app');
